module.exports = __webpack_public_path__ + "static/media/SUPPORTICON-01.a07a76b3.svg";